import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { CirrusButtonModule } from 'app/shared/cirrus/button/cirrus-button.module';
import { CirrusDescriptionModule } from 'app/shared/cirrus/description/cirrus-description.module';
import { CirrusCardModule } from '../shared/cirrus/card/cirrus-card.module';
import { CirrusDividerModule } from '../shared/cirrus/divider/cirrus-divider.module';
import { CirrusFieldWrapperModule } from '../shared/cirrus/field-wrapper/cirrus-field-wrapper.module';
import { SectionModule } from '../shared/cirrus/section/section.module';
import { CirrusTextModule } from '../shared/cirrus/text/cirrus-text.module';

import { ActionButtonModule } from '../shared/components/action-button/action-button.module';
import { BooleanModule } from '../shared/components/boolean/boolean.module';
import { LoaderButtonModule } from '../shared/components/buttons/loader-button/loader-button.module';
import { ComponentsModule } from '../shared/components/components.module';
import { DatepickerModule } from '../shared/components/datepicker/datepicker.module';
import { PaginationModule } from '../shared/components/pagination/pagination.module';
import { LsMultiSelectModule } from '../shared/components/select/multi/ls-multi-select/ls-multi-select.module';
import { LsSingleSelectModule } from '../shared/components/select/single/ls-single-select/ls-single-select.module';
import { ShiftSettingsModule } from '../shared/components/shift-settings/shift-settings.module';
import { SwitchTableModule } from '../shared/components/switch-table/switch-table.module';
import { NavigationModule } from '../shared/navigation/navigation.module';
import { SharedModule } from '../shared/shared.module';
import { CirrusShowcaseComponent } from './cirrus/cirrus-showcase.component';
import { ComponentsShowcaseComponent } from './components-showcase.component';
import { LsMultiCheckboxModule } from 'app/shared/form/ls-multi-checkbox/ls-multi-checkbox.module';

@NgModule({
  imports: [
    CommonModule,
    DatepickerModule,
    FormsModule,
    ReactiveFormsModule,
    LsSingleSelectModule,
    LsMultiSelectModule,
    LsMultiCheckboxModule,
    PaginationModule,
    SwitchTableModule,
    LoaderButtonModule,
    SharedModule,
    RouterModule,
    BooleanModule,
    ActionButtonModule,
    NavigationModule,
    ComponentsModule,
    ShiftSettingsModule,
    CirrusTextModule,
    CirrusDescriptionModule,
    CirrusCardModule,
    CirrusFieldWrapperModule,
    CirrusDividerModule,
    CirrusButtonModule,
    SectionModule
  ],
  declarations: [ComponentsShowcaseComponent, CirrusShowcaseComponent]
})
export class ComponentsShowcaseModule {}
